import type { ILanguageResources, ITranslationModule } from '../../../interfaces';
import { interpolate } from '../../../global';

class Id {
  private constructor() {}
  public static readonly prefix = 'UI.scripts.dealer-franchisee.conversation.WmBranchQuoteSupportNew.';
  public static readonly pleaseAddSupportSubject = `${Id.prefix}pleaseAddSupportSubject`;
  public static readonly pleaseProvideSupportInitialTopic = `${Id.prefix}pleaseProvideSupportInitialTopic`;
  public static readonly supportRequest = `${Id.prefix}supportRequest`;
  public static readonly supportSubject = `${Id.prefix}supportSubject`;
  public static readonly supportInitialTopic = `${Id.prefix}supportInitialTopic`;
  public static readonly saveDraft = `${Id.prefix}saveDraft`;
  public static readonly issueTicket = `${Id.prefix}issueTicket`;
  public static readonly cancel = `${Id.prefix}cancel`;
  public static readonly linkQuoteItems = `${Id.prefix}linkQuoteItems`;
  public static readonly updateLinkQuoteItems = `${Id.prefix}updateLinkQuoteItems`;
  public static readonly linkQuoteItemsLabel = `${Id.prefix}linkQuoteItemsLabel`;
}

export class LangBranchQuoteSupportNew {
  private constructor() {}
  public static pleaseAddSupportSubject(params: { supportType: string }): string {
    return interpolate(Id.pleaseAddSupportSubject, params);
  }
  public static pleaseProvideSupportInitialTopic(params: { supportType: string; supplierName: string }): string {
    return interpolate(Id.pleaseProvideSupportInitialTopic, params);
  }
  public static supportRequest(): string {
    return interpolate(Id.supportRequest);
  }
  public static supportSubject(): string {
    return interpolate(Id.supportSubject);
  }
  public static supportInitialTopic(): string {
    return interpolate(Id.supportInitialTopic);
  }
  public static saveDraft(): string {
    return interpolate(Id.saveDraft);
  }
  public static issueTicket(): string {
    return interpolate(Id.issueTicket);
  }
  public static cancel(): string {
    return interpolate(Id.cancel);
  }
  public static linkQuoteItems(): string {
    return interpolate(Id.linkQuoteItems);
  }
  public static updateLinkQuoteItems(): string {
    return interpolate(Id.updateLinkQuoteItems);
  }
  public static linkQuoteItemsLabel(): string {
    return interpolate(Id.linkQuoteItemsLabel);
  }
}

export class WmBranchQuoteSupportNewModule implements ITranslationModule {
  registerItems(register: ILanguageResources) {
    register.add(
      Id.pleaseAddSupportSubject,
      "Please add a {{glossary 'support-subject'}} to describe this {{supportType}}",
      'Validation error for missing support subject'
    );
    register.add(
      Id.pleaseProvideSupportInitialTopic,
      "Please provide a {{glossary 'support-initial-topic'}} before submitting this {{supportType}} ticket to {{supplierName}}",
      'Validation error for missing support initial topic'
    );
    register.add(Id.supportRequest, "{{glossary 'support-request'}}", 'Label for support request');
    register.add(Id.supportSubject, "{{glossary 'support-subject'}}", 'Label for support subject');
    register.add(Id.supportInitialTopic, "{{glossary 'support-initial-topic'}}", 'Label for support initial topic');
    register.add(Id.saveDraft, 'Save Draft', 'Button label for saving draft');
    register.add(Id.issueTicket, 'Issue Ticket', 'Button label for issuing ticket');
    register.add(Id.cancel, 'Cancel', 'Button label for cancel');
    register.add(Id.linkQuoteItems, `Link {{glossary 'quote-item:plural'}}`, 'Button label to link quote items');
    register.add(
      Id.updateLinkQuoteItems,
      `Update {{glossary 'quote-item:plural'}}`,
      'Button label to update linked quote items'
    );
    register.add(
      Id.linkQuoteItemsLabel,
      "You may optionally attach as many or as few related {{glossary 'quote-item:plural'}} as you need. If any linked item is edited after submission, that change may cancel this support request — you will need to reactivate it or submit a new request if it still applies.",
      'Label to link quote items (notes optional quantity and possible cancellation on edits)'
    );
  }
}
